import { startOfMonth, endOfMonth, formatISO } from 'date-fns';

const formatIsoLocalDate = (date: Date) => formatISO(date, { representation: 'date' });

export const getMonthDates = (month: number): { start: string; end: string } => {
	const year = new Date().getFullYear();
	const start = startOfMonth(new Date(year, month - 1));
	const end = endOfMonth(new Date(year, month - 1));
	return {
		start: formatIsoLocalDate(start),
		end: formatIsoLocalDate(end),
	};
};

export const getMonthFromDate = (start: string): number => parseInt(start.split('-')[1], 10);
